/* Evergreen in-page section scroll — Andrea Nicole / AOH.
 * Shopify regenerates the "template--<NUMBER>" prefix inside section element ids
 * whenever a theme is duplicated or republished, which silently breaks any button
 * linked to "#shopify-section-template--<NUMBER>__<suffix>". This handler re-resolves
 * such links at click time using the STABLE section suffix (e.g.
 * "featured_collection_YKGWYB"), so the link can never go stale, and adds smooth
 * scroll with a sticky-header offset. Added 2026-06-17.
 */
(function () {
  var HEADER_OFFSET = 90; // px, clears the sticky header
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#shopify-section-"]');
    if (!link) return;
    var hash = link.getAttribute('href').split('#').pop();
    if (!hash) return;
    var idx = hash.indexOf('__');
    if (idx === -1) return;
    var suffix = hash.slice(idx + 2);
    var target = document.getElementById(hash) || document.querySelector('[id$="__' + suffix + '"]');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
})();
